/**
 * DeletePosContagemConfirmModal - Confirmation dialog for deleting a PosContagemCliente record
 */
import React from 'react';
import { Trash2, Loader2, AlertTriangle } from 'lucide-react';
import type { PosContagemCliente } from '../../services/contagemService';

interface DeletePosContagemConfirmModalProps {
  isOpen: boolean;
  item: PosContagemCliente | null;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeletePosContagemConfirmModal: React.FC<DeletePosContagemConfirmModalProps> = ({
  isOpen,
  item,
  isDeleting,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen || !item) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-md w-full">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex items-center gap-3">
          <div className="p-2 bg-red-100 dark:bg-red-900/30 rounded-full">
            <AlertTriangle className="w-6 h-6 text-red-600 dark:text-red-400" />
          </div>
          <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
            Confirmar Exclusão
          </h3>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-gray-600 dark:text-gray-400">
            Tem certeza que deseja excluir a pós-contagem do cliente{' '}
            <strong className="text-gray-800 dark:text-gray-200">
              {item.cliente_nome}
            </strong>
            ?
          </p>
          <p className="mt-2 text-sm text-gray-500 dark:text-gray-500">
            Esta ação não pode ser desfeita.
          </p>
        </div>

        {/* Actions */}
        <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700 flex justify-end gap-3">
          <button
            onClick={onCancel}
            disabled={isDeleting}
            className="px-4 py-2 text-gray-600 dark:text-gray-400 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg transition font-medium disabled:opacity-50"
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            disabled={isDeleting}
            className="flex items-center gap-2 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition font-medium disabled:opacity-50"
          >
            {isDeleting ? (
              <>
                <Loader2 size={16} className="animate-spin" />
                Excluindo...
              </>
            ) : (
              <>
                <Trash2 size={16} />
                Excluir
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
